import { render, staticRenderFns } from "./PopulateV3.vue?vue&type=template&id=edb72676"
import script from "./PopulateV3.vue?vue&type=script&lang=js"
export * from "./PopulateV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports